/* Reusable "shrink → hold → fade" scroll effect for a title / hero block.
   Add data-collapse to any element.

   SILKY BY DESIGN: it does NOT pin/translate the element on scroll (a JS position-pin lags
   the scroll by a frame and looks janky, and native position:sticky has no runway in a short
   header section). The element rides the browser's own smooth scroll; JS only scrubs SCALE and
   OPACITY, where a frame of lag is imperceptible. So it shrinks in place, holds small, then
   fades as it scrolls up — no jitter.

   Optional data attributes:
     data-collapse-scale   min scale in the shrink phase      (default 0.5)
     data-collapse-shrink  px of scroll for the shrink phase  (default 110)
     data-collapse-hold    px it stays shrunk before fading   (default 0)
     data-collapse-fade    px of scroll for the fade phase    (default 150)
     data-collapse-origin  transform-origin override (default: derived from text-align)

   Respects prefers-reduced-motion (leaves the element static). */
(function () {
  const clamp = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function navHeight() {
    let h = 0;
    document.querySelectorAll('[class*="section-group-header"]').forEach((el) => {
      const pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') h = Math.max(h, el.getBoundingClientRect().height);
    });
    return h;
  }

  class ScrollCollapse {
    constructor(el) {
      this.el = el;
      // Collection titles slide to the right on scroll-down (and back left on scroll-up);
      // everything else keeps the shrink → hold → fade.
      this.slide = !!el.closest('.collection-banner-section');
      this.minScale = parseFloat(el.dataset.collapseScale || '0.5');
      this.shrink = parseFloat(el.dataset.collapseShrink || '110');
      this.hold = parseFloat(el.dataset.collapseHold || '0');
      this.fade = parseFloat(el.dataset.collapseFade || '150');

      let origin = el.dataset.collapseOrigin;
      if (!origin) {
        const ta = getComputedStyle(el).textAlign;
        origin = ta === 'center' ? 'center top' : ta === 'right' ? 'right top' : 'left top';
      }
      el.style.transformOrigin = origin;
      el.style.willChange = 'transform, opacity';

      this.raf = 0;
      this.measure();
      this._onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => this.update()); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', () => { this.measure(); this.update(); }, { passive: true });
      window.addEventListener('load', () => { this.measure(); this.update(); });
      this.update();
    }

    measure() {
      const prev = this.el.style.transform;
      this.el.style.transform = '';
      const r = this.el.getBoundingClientRect();
      this.docTop = r.top + window.scrollY;
      this.el.style.transform = prev;
      this.nav = navHeight();
    }

    update() {
      this.raf = 0;
      if (reduce.matches) { this.el.style.transform = ''; this.el.style.opacity = ''; return; }
      const start = Math.max(0, this.docTop - this.nav);
      const t = window.scrollY - start;
      if (t <= 0) { this.el.style.transform = ''; this.el.style.opacity = ''; return; }
      if (this.slide) {
        // Slide all the way right over 340px of scroll; reverses as you scroll back up.
        const p = clamp(t / 340);
        this.el.style.transform = `translateX(${(p * window.innerWidth * 1.1).toFixed(1)}px)`;
        this.el.style.opacity = '';
        return;
      }
      const p1 = clamp(t / this.shrink);
      const p2 = clamp((t - this.shrink - this.hold) / this.fade);
      const scale = 1 - (1 - this.minScale) * p1;
      this.el.style.transform = `scale(${scale})`;
      this.el.style.opacity = String(1 - p2);
    }
  }

  function init() {
    // Modern browsers run the silky compositor version in CSS (@supports animation-timeline);
    // only fall back to this JS (no pin) where scroll-driven animations aren't supported.
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()')) return;
    document.querySelectorAll('[data-collapse]').forEach((el) => {
      if (!el._scrollCollapse) el._scrollCollapse = new ScrollCollapse(el);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
